import { Badge, Box, Tooltip } from "@prismicio/editor-ui"

import {
  type MetadataType,
  metaDescriptionConfig,
  metaDescriptionProperty,
  metaTitleConfig,
  metaTitleProperty,
} from "../../service"

interface MetadataBadgeProps {
  type: MetadataType
  value: string
}

export function MetadataBadge(props: MetadataBadgeProps) {
  const { type, value } = props

  const characterLimit =
    type === metaTitleProperty ? metaTitleConfig.max : metaDescriptionConfig.max

  return (
    <Box alignItems="center">
      <Tooltip
        title={metadataTooltipTitle[type]}
        content={metadataTooltipContent[type]}
        stableMount
      >
        <Badge
          title={`${value.length} characters`}
          size="medium"
          color={value.length > characterLimit ? "tomato" : "green"}
          sx={{ alignSelf: "center" }}
        />
      </Tooltip>
    </Box>
  )
}

const metadataTooltipTitle: Record<MetadataType, string> = {
  [metaTitleProperty]: "Meta title length",
  [metaDescriptionProperty]: "Meta description length",
}

const metaTitleTargetRange = `${metaTitleConfig.min}-${metaTitleConfig.max}`
const metaDescriptionTargetRange = `${metaDescriptionConfig.min}-${metaDescriptionConfig.max}`

const metadataTooltipContent: Record<MetadataType, string> = {
  [metaTitleProperty]: `For optimal mobile SEO, keep your meta title within ${metaTitleTargetRange} characters to prevent it from being cut off in search results.`,
  [metaDescriptionProperty]: `To ensure your meta description isn’t truncated in mobile search results, aim for ${metaDescriptionTargetRange} characters. This helps improve visibility and click-through rates.`,
}
